import { Injectable, ViewChildren, QueryList } from '@angular/core';
import { IonRouterOutlet, ActionSheetController, PopoverController, ModalController, MenuController, ToastController } from '@ionic/angular/standalone';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AutocloseOverlaysService {
  constructor(
    private actionSheetCtrl: ActionSheetController,
    private popoverCtrl: PopoverController,
    private modalCtrl: ModalController,
    private menu: MenuController,
  ) { }
  async trigger(state?: { [k: string]: any; }) {
    // close action sheet
    try {
      const element = await this.actionSheetCtrl?.getTop();
      if (element) {
        element?.dismiss();
        return true;
      }
    } catch (error) {
      console.error(error)
    }

    // close popover
    try {
      const element = await this.popoverCtrl?.getTop();
      if (element) {
        element?.dismiss();
        return true;
      }
    } catch (error) {
      console.error(error)
    }

    // close modal
    try {
      const element = await this.modalCtrl?.getTop();

      // Navigazione AUTOMATICA (auto-skip delle schermate a un solo elemento: Home→bandi,
      // bandi→tipologia, tipologia→pratica) su una modale che si dichiara sicura: si lascia
      // aperta E si lascia passare la navigazione (`false` → canDeactivate=true). Serve alla
      // notifica push, che compare appena il login è concluso e finiva richiusa dal salto che
      // la Home decide quando risponde il catalogo — con la beffa che il salto veniva anche
      // annullato, perché chiudere un overlay qui significa negare la navigazione.
      //
      // Le due condizioni sono entrambe necessarie e vanno lette insieme: la NAVIGAZIONE
      // dichiara di essere automatica e la MODALE dichiara di poter sopravvivere a un cambio
      // pagina. Il solo `autoSkip` esenterebbe qualunque overlay in cima durante un salto,
      // ben oltre il caso che si vuole coprire.
      //
      // Diverso da `isNotDismissableWithBack` sotto: quello blocca ANCHE il tasto indietro.
      // Qui no — il back non passa `autoSkip`, quindi cade nel ramo normale e chiude la
      // modale come sempre, che è ciò che l'utente si aspetta dal tasto fisico.
      if (!!state?.['autoSkip'] && !!(element as any)?.componentProps?.isAutoSkipSafe) {
        // Il menu laterale, se aperto, va comunque chiuso: qui si esce prima del blocco in coda
        // che se ne occupa, e nessun chiamante lo chiude per questa via (a differenza di `skip` e
        // `loggingOut`, dove lo fa il chiamante). Senza questo resterebbe aperto sulla pagina
        // nuova dopo il salto.
        await this.chiudiMenuSeAperto();
        return false;
      }

      // quest'if serve per non chiudere modali e per non cambiare pagina. La dismiss
      // deve funzionare solo con la dismiss delle modali
      if (!!(element as any)?.componentProps?.isNotDismissableWithBack) {
        return true;
      }
      if (element) {
        element?.dismiss();
        return true;
      }
    } catch (error) {
      console.error(error)
    }

    // close side menu — solo sul back classico (`!skip`): annulla la navigazione e chiude il
    // menu. Con `skip:true` (navigazione da voce di menu) la chiusura la fa esplicitamente il
    // chiamante (menu.component) DOPO il navigateRoot: chiudere anche qui produrrebbe due
    // close() concorrenti sullo stesso menu durante il cambio rotta, lasciando il
    // MenuController singleton in stato incoerente (poi il pulsante ☰ non riapre).
    if (!state?.['skip']) {
      if (await this.chiudiMenuSeAperto()) {
        return true;
      }
    }
    return false;
  }

  /** Chiude il menu laterale se aperto. `true` se c'era qualcosa da chiudere. */
  private async chiudiMenuSeAperto(): Promise<boolean> {
    try {
      const element = await this.menu?.getOpen();
      if (element != null) {
        await this.menu?.close();
        return true;
      }
    } catch (error) {
      console.error(error)
    }
    return false;
  }

}
